<template>
  <div>
    <div class="clearfix"></div>
    <div class="row" v-if="ticketId">
      <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-content" style="min-height:300px;">
            <div class="row">
              <div class="marvel-device nexus5">
                <div class="top-bar"></div>
                <div class="sleep"></div>
                <div class="volume"></div>
                <div class="camera"></div>
                <div class="screen">
                  <div class="screen-container">
                    <div class="status-bar">
                      <div class="time"></div>
                      <div class="battery">
                        <i class="zmdi zmdi-battery"></i>
                      </div>
                      <div class="network">
                        <i class="zmdi zmdi-network"></i>
                      </div>
                      <div class="wifi">
                        <i class="zmdi zmdi-wifi-alt-2"></i>
                      </div>
                      <div class="star">
                        <i class="zmdi zmdi-star"></i>
                      </div>
                    </div>
                    <div class="chat">
                      <div class="chat-container">
                        <div class="user-bar">
                          <div class="back">
                            <i class="zmdi zmdi-arrow-left"></i>
                          </div>
                          <div class="name">
                            <span>{{ $t('support_team') }}</span>
                          </div>
                          <div class="caseNumber">
                            <span>{{ $t('support_case') }} #{{ticketData.code}}</span>
                          </div>
                        </div>
                        <div class="conversation">
                          <div class="conversation-container" id="ticketContentContainer">
                            <!--- Initial Ticket --->
                            <div class="message" :class="{sent: ticketData.direction == 'user' , received: ticketData.direction !== 'user'}">
                              {{ ticketData.message }}<br/>
                              <span class="metadata"><br/>
                                <div class="attachments" v-if="(ticketData.attachments) && (ticketData.attachments.length > 0)">
                                    <a
                                      v-if="ticketData.attachments.length > 1"
                                      href="#"
                                      @click="downloadFile(ticketData.id)"
                                      data-tooltip="Download all as ZIP"
                                    >
                                      <i class="fas fa-file-archive"></i> {{ $t('download_all_attachments_as_zip') }} |
                                    </a><br/>
                                  <ul>
                                    <li v-for="attachment in ticketData.attachments">
                                      <a href="#" class="atch-thumb"></a>
                                      <div class="file-name">{{ attachment }}<br/><br/></div>
                                      <div class="links">
                                        <a
                                        class="btn btn-xs"
                                          href="#"
                                          @click="downloadFile(ticketData.id, attachment)"
                                        >
                                          <i class="fas fa-file-download"></i> {{ $t('download') }}
                                        </a>
                                      </div>
                                    </li>
                                  </ul>
                                  <br/><br/><span class="time">{{ ticketData.created_at }}</span>
                                  <span class="double_tick" v-if="childTicket.user_status == 'read' "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#4fc3f7"/></svg></span>
                                  <span class="double_tick" v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#000"/></svg></span>
                                </div>
                                <span v-else class="time">{{ ticketData.created_at }}</span>
                              </span>
                            </div>
                            <!--- END initial Ticket --->
                            <div
                              v-for="(childTicket, key) in ticketData.children"
                              class="message"
                              :class="{sent: childTicket.direction == 'user' , received: childTicket.direction !== 'user'}"
                            >
                              {{ childTicket.message }}<br/><br/>
                              <span class="metadata"><br/>
                                <div class="attachments" v-if="(childTicket.attachments) && (childTicket.attachments.length > 0)">
                                    <a
                                      v-if="childTicket.attachments.length > 1"
                                      href="#"
                                      @click="downloadFile(childTicket.id)"
                                    >
                                      <i class="fas fa-file-archive"></i> {{ $t('download_all_attachments_as_zip') }}<br/><br/>
                                    </a>
                                  <ul>
                                    <li v-for="attachment in childTicket.attachments">
                                      <a href="#" class="atch-thumb"></a>
                                      <div class="file-name" :alt="attachment" :title="attachment">{{ attachment | truncate(25) }}<br/></div>
                                      <div class="links">
                                        <a
                                        class="btn btn-xs"
                                          href="#"
                                          @click="downloadFile(childTicket.id, attachment)"
                                        >
                                          <i class="fas fa-file-download"></i> {{ $t('download') }}
                                        </a><br/><br/>
                                      </div>
                                    </li>
                                  </ul>
                                  <br/><br/><span class="time">{{ childTicket.created_at }}</span>
                                </div>
                                <span v-else class="time">{{ childTicket.created_at }}</span>
                                <span class="double_tick" v-if="childTicket.user_status == 'read' "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#4fc3f7"/></svg></span>
                                <span class="double_tick" v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#000"/></svg></span>
                              </span>
                            </div>
                          </div>
                          <div class="action-bar no-print">
                            <div class="col-md-12">
                              <div class="case-statuses">
                                <button
                                  class="btn btn-sm btn-default"
                                  type="button"
                                  data-tooltip="Print"
                                  @click="printWindow()"
                                >
                                  <i class="fa fa-print"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="conversation-compose no-print">
                            <input
                              class="input-msg"
                              v-model="ticketReplyData.replyMessage"
                              name="input"
                              :placeholder="$t('type_your_reply_and_hit_enter')"
                              autocomplete="off"
                              autofocus
                            />
                            <button class="send" @click="sendReply" :disabled="isProcessing">
                              <div class="circle">
                                <i class="fas fa-arrow-circle-right"></i>
                              </div>
                            </button>
                          </div>

                          <vue-dropzone
                            class="no-print"
                            ref="filedropper"
                            id="filedropper"
                            :options="dropzoneOptions"
                            v-on:vdropzone-success-multiple="uploadSuccess"
                            style="font-family: 'Roboto', Arial, Verdana; "
                          ></vue-dropzone>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 no-print">
        <div class="card" v-if="ticketData.file_id && ticketData.file">
  <div class="card-header">
    <h3>{{ $t('ticket_details') }}</h3>
    <div class="clearfix"></div>
    <table class="table table-hover">
      <tbody>
        <tr>
          <td>{{ $t('subject') }}</td>
          <td>{{ ticketData.subject }}</td>
        </tr>
        <tr>
          <td>{{ $t('created_at') }}</td>
          <td>{{ ticketData.created_at }}</td>
        </tr>
        <tr>
          <td>{{ $t('status') }}</td>
          <td>{{ ticketData.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="card-header">
    <h3>{{ $t('file_details') }}</h3>
    <div class="clearfix"></div>
  </div>
  <div class="card-content">
    <table class="table table-hover">
      <tbody>
        <tr>
          <td>{{ $t('type') }}</td>
          <td v-if="ticketData.file.type">{{ ticketData.file.type }}</td>
          <td v-else>{{ $t('unknown') }}</td>
        </tr>
        <tr>
          <td>{{ $t('status') }}</td>
          <td>{{ ticketData.file.status }}</td>
        </tr>
        <tr v-for="(file, k) in ticketData.file.files">
          <td colspan="2">
            <a
              href="#"
              @click="downloadFileserviceFile(ticketData.file.id, file.name)"
              :data-tooltip="$t('download_file')"
            >
              <i class="fas fa-file-download text-success"></i>
              {{ file.name }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

  </div>
  </div>
<div v-if="!ticketId">
  <h4>{{ $t('please_load_ticket_to_show_details') }}</h4>
</div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: ["ticketId"],
  components: {
    vueDropzone: vue2Dropzone,
  },
  data: function () {
    return {
      isProcessing  : false,
      ticketData: "",
      subTicketData: "",
      ticketReplyData: { replyMessage: "", files: "" },
      showReplybox: false,
      selectedChildTicket: ""
      ,
      dropzoneOptions: {
        paramName: "files",
        url: APIURL + "/tickets/" + this.ticketId + "/upload",
        maxNumberOfFiles: 5,
        uploadMultiple: true,
        parallelUploads: 3,
        thumbnailWidth: 100,
        maxFilesize: 25,
        timeout: 180000,
        dictDefaultMessage:
          "<h3><i class='fa fa-cloud-upload-alt fa-2x'></i></h3><h3>" + this.$t('select_files_to_upload') + "</h3>",
      },
    };
  },
  mounted: function () {
  },
  methods: {
    noenter() {
      return !(window.event && window.event.keyCode == 13); 
    },
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    loadTicketDetails(ticketId, reload = false, activateSocket = false) {
      if (!reload) {
        this.ticketData = "";
      }
      Webservice.getTicket(ticketId)
        .then((response) => {
          this.ticketData = response.data;
          this.subTicketData = response.data;
          if (!reload) {
            setTimeout(function () {
              $("#ticketContentContainer").animate(
                {
                  scrollTop: $("#ticketContentContainer").prop("scrollHeight"),
                },
                1000
              );
            }, 1500);
          } else {
            $("#ticketContentContainer").animate(
              { scrollTop: $("#ticketContentContainer").prop("scrollHeight") },
              500
            );
          }
          //also get tickets / files and transactions / credits
          this.updateUrl();
          if (response.data.children.length > 0) {
            this.loadChildTicket(response.data.children.length - 1);
          }
          if(activateSocket) {
            this.listenToSocket();
          }
        })
        .catch((error) => {
          this.$notify({
            component: {
              template:
                "<span>" + this.$t('something_went_wrong_sending_ticket')+ "</span>",
            },
            icon: "fas fa-exclamation-triangle",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "error",
          });
        });
    },
    updateUrl() {
      if (typeof this.$refs.filedropper !== "undefined") {
        setTimeout(() => {
          this.$refs.filedropper.setOption(
            "url",
            APIURL + "/tickets/" + this.ticketId + "/upload"
          );
          this.$refs.filedropper.setOption("headers", {
            Authorization: `Bearer ${localStorage.access_key}`,
            "CTR-Access-Key": SITEKEY,
          });
        }, 3000);
      }
    },
    save() {
      this.$emit("ticketSaved");
    },
    readTicketmessage(ticketId) {
      this.$router.push({ name: "tickets", params: { ticketId: ticketId } });
    },
    loadChildTicket(key) {
      this.subTicketData = this.ticketData.children[key];
      this.subTicketData["key"] = key;
      this.showReplybox = false;
      this.selectedChildTicket = key;
    },
    loadInitialTicket(key) {
      this.subTicketData = this.ticketData;
      this.showReplybox = false;
      this.selectedChildTicket = key;
    },
    openFile(fileId) {
      this.$router.push({ name: "fileservice", params: { fileId: fileId } });
    },
    uploadSuccess(file, response) {
      if (response) {
        this.ticketReplyData.files = response;
        this.$notify({
        component: {
          template:
            "<span>" +  this.$t('success') + "<br/>" +  this.$t('files_uploaded') + "</span>",
        },
        icon: "fas fa-check",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success",
      });
      }
    },
    downloadFile(ticketId, filename = null) {
      Webservice.downloadTicketFile(ticketId, filename).then((resp) => {
        if (resp.headers) {
          var headers = resp.headers;
          var a = document.createElement("a");
          let contenttype = resp.headers["content-type"];

          var blob = new Blob([resp.data], { type: contenttype });
          var url = window.URL.createObjectURL(blob);

          a.style = "display: none";
          a.href = url;
          if (typeof filename === "undefined") {
            filename = "archive_download_" + fileId;
          }
          a.download = filename;

          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 1500);
        }
      });
    },
    downloadFileserviceFile(fileId, filename) {
      Webservice.downloadFile(fileId, filename).then((resp) => {
        if (resp.headers) {
          var headers = resp.headers;
          var a = document.createElement("a");
          let contenttype = resp.headers["content-type"];

          var blob = new Blob([resp.data], { type: contenttype });
          var url = window.URL.createObjectURL(blob);

          a.style = "display: none";
          a.href = url;
          if (typeof filename === "undefined") {
            filename = "archive_download_" + fileId;
          }
          a.download = filename;

          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 1500);
        }
      });
    },
    sendReply() {
      this.isProcessing = true;
      Webservice.sendTicketReply(this.ticketId, this.ticketReplyData).then(
        (response) => {
          if (response.data == "success") {
            this.$notify({
              component: {
                template:
                  "<span>" +  this.$t('reply_sent') + "<br/>" +  this.$t('engineers_will_reply_asap') + "</span>",
              },
              icon: "fas fa-check",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success",
            });
            this.ticketReplyData = { replyMessage: "", files: "" };
            this.loadTicketDetails(this.ticketId, true);
            this.isProcessing = false;
          } else {
            this.$notify({
              component: {
                template:
                  "<span>" +  this.$t('error') + "<br/>" + this.$t('something_went_wrong_sending_ticket') + "</span>",
              },
              icon: "fas fa-check",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "error",
            });
          }
        }
      ).catch((err) => {
        if(err.response.status == 429) {
          this.$notify({
              component: {
                template:
                  "<span>" +  this.$t('error') + "<br/>" + this.$t('too_many_attempts_try_again_later') + "</span>",
              },
              icon: "fas fa-ban",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "error",
            });
        } else {
          this.$notify({
              component: {
                template:
                  "<span>" +  this.$t('error') + "<br/>" + this.$t('something_went_wrong_sending_ticket') + "</span>",
              },
              icon: "fas fa-ban",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "error",
            });
        }
      });
    },
    printWindow() {
      window.print();
    },
    listenToSocket() {
      window.Echo.channel(
        `customer.${SITEKEY}.${this.ticketData.customer_id}`
      ).listen(".ticket-update", (e) => {
        if (e.ticket_id == this.ticketData.id) {
          this.loadTicketDetails(this.ticketData.id, true);
          return;
        }
        return;
      });
    },
  },
};
</script>
<style scoped>
.initialTicketBlock {
  border-bottom: 3px dotted #c0c0c0;
}
.view-mail {
  padding-top: 15px;
  font-size: 1.5em !important;
}
.selected .mail_list {
  font-weight: bold;
  background-color: #c0c0c0;
}
.metadata {
  border-top: 1px solid #ccc;
  margin-top: 10px;
}
.file-name {
  padding-bottom: 10px;
}
.caseNumber {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/ticket.vue